module.exports = __webpack_public_path__ + "static/img/bg.697d7088.png";